import { Outlet, useNavigate } from "react-router-dom";
import LicenseManager from "../License/LicenseManager";
import NavWrapper from "./NavWrapper";
import "./Nav.scss"
import Container from 'react-bootstrap/Container';
import { default as BSNav } from 'react-bootstrap/Navbar';
import { Button, DropDownButton, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import Nav from 'react-bootstrap/Nav';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useContext, useRef, useState } from "react";
import * as bootstrap from "bootstrap";
import { RevUserContextType, RevUserContext } from "../../context/UserContext";
import { isMobile } from "react-device-detect";
import { Avatar } from "@progress/kendo-react-layout";
import { useReduxDispatch } from "../../redux/hooks";
import { updateIframeSrc } from "../../slices/RevelationSlice";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svg from '@progress/kendo-svg-icons';
import { NavItems } from "../../types/User/IUserProfile";
import Form from 'react-bootstrap/Form';

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useReduxDispatch();
  const { headerText, profile } = useContext<RevUserContextType>(RevUserContext);
  const [ticketId, setTicketId] = useState(null as number | null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const profileItems = ['Help', 'Sign Out'];

  const profileItemClicked = (item: DropDownButtonItemClickEvent) => {
    console.log('Profile item clicked:', item);
    switch (item.item) {
      case 'My Profile':
        // Navigate to profile page
        navigate(`/user/${profile?.Id}`);
        //dispatch(updateIframeSrc(`/contacts/contactinfo.aspx?contact_id=${profile?.Id}`));
        break;
      case 'Help':
        // Open help page
        profile?.Help_Url && window.open(profile?.Help_Url, '_blank');
        break;
      case 'Sign Out':
        // Handle sign out logic
        navigate('/signout');
        break;
      default:
        break;
    }
  }

  const menuItemClicked = (item: NavItems) => {
    const offcanvas = document.querySelector('.offcanvas');
    console.log('Menu item clicked:', item);
    if (item.Url) {
      // If the item has a URL, navigate to it
      if (item.Url.startsWith('./')) {
        // If the URL is a relative path, navigate within the app
        navigate(item.Url.replace('./', '/'));
      } else {
        //Embedded aspx page
        if (item.Name === 'Home')
          navigate("/");
        else {
          navigate("/rev");
          dispatch(updateIframeSrc(item.Url));
        }
      }

      //close the canvas
      setShow(false);

    }
  }

  let expand = 'lg';
  return (
    isMobile ?
      <>
        <BSNav expand="lg" className="cool-nav bg-body-tertiary" sticky="top">
          <Container fluid>
            <div>
              <BSNav.Toggle onClick={() => setShow(true)} aria-controls={`offcanvasNavbar-expand-${expand}`}><SvgIcon icon={svg.menuIcon} /></BSNav.Toggle>
              <BSNav.Brand href="./"><img className="p-2" src='./images/Host_Images/Logo/img_rev_logo_hover.png'></img>{headerText || 'Revelation helpdesk'}
              </BSNav.Brand>
            </div>
            <BSNav.Offcanvas show={show} onHide={handleClose}
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="start"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <img className="p-2" src='./images/Host_Images/Logo/img_rev_logo_hover.png'></img> Revelation helpdesk
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="m-0 p-0" style={{ color: '#fff' }} >
                <Nav className="flex-grow-1 cool-nav-items ">
                  {profile?.Nav_Items.filter(f => f.Name === 'Home' || f.Name === 'Log_a_Ticket').map(n =>
                    <Nav.Link key={n.Name} className="cool-nav-link" style={{ backgroundColor: profile?.Nav_Hex_Color, color: '#fff' }} onClick={() => menuItemClicked(n)} title={n.Tooltip}><img className="nav-image" src={`.${n.Image_Url}`} />{n.Text}</Nav.Link>
                  )}
                </Nav>
                <Nav className="justify-content-end flex-grow-1 cool-nav-items ">
                  <Form className="d-flex m-3 m-lg-0" onSubmit={(e) => {
                    e.preventDefault();
                  }}>
                    <Form.Control
                      type="number"
                      minLength={4}
                      placeholder={`Jump to ${profile?.Phrases?.CallPhrase} #`}
                      className="me-2"
                      aria-label="Search"
                      onKeyDown={(e) => {
                        console.log('Key onKeyDown:', e.key, ticketId);
                        if (e.key === 'Enter' && ticketId >= 1000) {
                          navigate(`/ticket/${ticketId}`);
                          setShow(false);
                          setTicketId(null);
                        }
                      }}
                      onKeyUp={(e) => {
                        console.log('Key pressed:', e.key);
                        const strTicketId = (e.target as HTMLInputElement).value;
                        if (!isNaN(parseInt(strTicketId))) {
                          setTicketId(parseInt(strTicketId));
                        }
                        if (e.key === 'Enter') {

                        }
                      }}
                    />
                    <Button type="button" disabled={!ticketId || ticketId <= 1000} onClick={() => {
                      if (ticketId) {
                        navigate(`/ticket/${ticketId}`);
                        setShow(false);
                        setTicketId(null);
                      }
                    }}>Go<SvgIcon icon={svg.chevronRightIcon} /></Button>

                  </Form>
                </Nav>
              </Offcanvas.Body>
            </BSNav.Offcanvas>
            <DropDownButton popupSettings={{ popupClass: "profile-options" }} onItemClick={profileItemClicked} text={
              <Avatar type="image" size="medium" className="profile-image">
                <img src={profile?.Profile_Image_Url || './images/placeholder.png'} alt="Profile" />
              </Avatar>
            } items={profileItems} fillMode={'flat'} />
          </Container>
        </BSNav >
        <Outlet />
      </>
      :
      <section className="relative grow full-size">
        <NavWrapper />
        <Outlet />
        <LicenseManager />
      </section>
  );
};

export default Navbar;